module.exports = __webpack_public_path__ + "img/upload-csv01.f2506bcf.png";